import { render, staticRenderFns } from "./FaqExamples.vue?vue&type=template&id=1b68f472&scoped=true&"
import script from "./FaqExamples.vue?vue&type=script&lang=js&"
export * from "./FaqExamples.vue?vue&type=script&lang=js&"
import style0 from "./FaqExamples.vue?vue&type=style&index=0&id=1b68f472&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b68f472",
  null
  
)

export default component.exports